import { initialState, CatalogueState } from './catalogue.state'
import { createReducer, on, ActionReducer, Action } from '@ngrx/store'
import { InjectionToken } from '@angular/core'
import * as CatalogueActions from './catalogue.actions'

export const catalogueReducer = createReducer(
  initialState,
  on(CatalogueActions.catalogueRetrieved, (state, action) => {
    return {
      ...state,
      catalogues: state.catalogues.find((catalogue) => catalogue.hrid === action.catalogue.hrid)
        ? state.catalogues
        : state.catalogues.concat(action.catalogue)
    }
  }),
  on(CatalogueActions.catalogueModified, (state, action) => {
    return {
      ...state,
      catalogues: state.catalogues.filter((catalogue) => catalogue.id !== action.id)
    }
  })
)

export function publicCatalogueReducer(state: CatalogueState, action: Action) {
  return catalogueReducer(state, action)
}

export const CATALOGUE_REDUCER = new InjectionToken<ActionReducer<CatalogueState>>('Catalogue Reducer')
